import React, { useState, useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import axios from "axios";

//Custom Components
import ChartCard from "../../components/Cards/ChartCard";
import CardLegend from "../../components/Cards/CardLegend";
import Loader from "../../components/Loader/Loader";
import { Wrapper } from "../../components";

//MockData
import totalPeopleConfig from "./totalPeopleConfig";
import {
  SECTOR_STATISTICS_BASE_URL,
} from "../../constants";


const useStyles = makeStyles((theme) => ({
  innerGrid: {
    position: "relative",
  },
  chartContainer: {
    position: "relative",
    width: "100%",
    height: "55vh",
    [theme.breakpoints.down("lg")]: {
      height: "37vh",
    },
  },
}));

export const EvacuadosPorSector = (props) => {
  const classes = useStyles();
  const chartEl = useRef(null);
  const { year } = props;

  const APIURL = `${SECTOR_STATISTICS_BASE_URL}`;

  const [homeData, setHomeData] = useState(null);
  const [, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      setLoading(true);
      const homeData = await axios.get(APIURL).then((data) => {
        return data.data;
      });
      setHomeData(homeData);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sectorPrivado = homeData ? _.find(homeData, {'title': 'Sector Privado' }) : null;
  const sectorPublico = homeData ? _.find(homeData, {'title': 'Sector Público' }) : null;
  const sociedadCivil = homeData ? _.find(homeData, {'title': 'Comunidades' }) : null;

  const totalPeopleData = totalPeopleConfig([sectorPublico?.total, sectorPrivado?.total, sociedadCivil?.total]);
    
  const totalPeoplelegend = [
    {
      legend: sectorPublico?.title,
      color: "#A48AD4",
      border: "#7E57C2",
      amount: sectorPublico?.total,
    },
    {
      legend: sectorPrivado?.title,
      color: "#4EC2F7",
      border: "#03A9F4",
      amount: sectorPrivado?.total,
    },
    {
      legend: sociedadCivil?.title,
      color: "#B7E29E",
      border: "#B2CEA1",
      amount: sociedadCivil?.total,
    },
  ];

  return (
    <Wrapper>
      <Grid container spacing={1} justify="center">
        <Grid className={classes.innerGrid} item xs={12} sm={10} md={10}>
          <ChartCard
            title={totalPeopleData.title}
            subheader={totalPeopleData.subtitle}
            expand={true}
            bottom={180}
            year={year}
          >
            {totalPeopleData.type === "doughnut" && (
              <div className={classes.chartContainer}>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <Doughnut
                      data={totalPeopleData.data}
                      height={totalPeopleData.height}
                      options={totalPeopleData.options}
                      ref={chartEl}
                    />
                    <CardLegend options={totalPeoplelegend} />
                  </>
                )}
              </div>
            )}
          </ChartCard>
        </Grid>
      </Grid>
    </Wrapper>
  );
};
